<template>
    <a-card title="投资经理">
        <div class="border-t">
            <a-form ref="ruleForm" :model="form" :rules="rules" :isModal="false">
                <!--可编辑区域 start-->
                <div class="hidden">
                    <a-form-item label="id" name="id">
                        <a-input v-model:value="form.id" />
                    </a-form-item>
                </div>
                <a-col class="hidden" :span="12">
                    <a-form-item label="审核状态：0 待审核，1 审核通过，2 审核未通过" name="auditStatus">
                        <a-input v-model:value="form.auditStatus" placeholder="请输入审核状态：0 待审核，1 审核通过，2 审核未通过" />
                    </a-form-item>
                </a-col>
                <table class="my-table">
                    <tbody>
                        <tr>
                            <td colspan="24">
                                <a-form-item label="投资经理头像" name="logo">
                                    <img-upload v-model:value="form.logo" />
                                </a-form-item>
                            </td>
                        </tr>

                        <tr>
                            <td colspan="12">
                                <a-form-item label="投资经理姓名" name="name">
                                    <a-input v-model:value="form.name" placeholder="请输入投资经理姓名" />
                                </a-form-item>
                            </td>

                            <td colspan="12">
                                <a-form-item label="邮箱" name="email">
                                    <a-input v-model:value="form.email" placeholder="请输入邮箱" />
                                </a-form-item>
                            </td>
                        </tr>

                        <tr>
                            <td colspan="12">
                                <a-form-item label="联系电话" name="contactNumber">
                                    <a-input v-model:value="form.contactNumber" placeholder="请输入联系电话" />
                                </a-form-item>
                            </td>
                            <td colspan="12">
                                <a-form-item label="身份证号" name="employeeCard">
                                    <a-input v-model:value="form.employeeCard" placeholder="请输入身份证号" />
                                </a-form-item>
                            </td>
                        </tr>

                        <tr>
                            <td colspan="8">
                                <a-form-item label="所在地区" name="prov">
                                    <city-select v-model:prov="form.prov" v-model:city="form.city" v-model:dist="form.dist"
                                        placeholder="请选择省/市/区" />
                                </a-form-item>
                            </td>
                            <td colspan="8">
                                <a-form-item label="详细地址" name="address">
                                    <a-input v-model:value="form.address" placeholder="请输入详细地址" />
                                </a-form-item>
                            </td>
                            
                            <td colspan="8">
                                <a-form-item label="投资领域" name="investmentField">
                                    <multiple-select v-model:value="form.investmentField" :options="options" title-name="name" value-name="id"/>
                                </a-form-item>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="24">
                                <a-form-item label="投资经理简介" name="introduce">
                                    <a-textarea v-model:value="form.introduce" placeholder="请输入投资经理简介"
                                        :auto-size="{ minRows: 5, maxRows: 6 }" />
                                </a-form-item>
                            </td>
                        </tr>
                        <tr>
                            <td colspan="24">
                                <a-form-item label="投资案例" name="investmentCase">
                                    <a-textarea v-model:value="form.investmentCase" placeholder="请输入投资案例"
                                        :auto-size="{ minRows: 5, maxRows: 6 }" />
                                </a-form-item>
                            </td>
                        </tr>
                    </tbody>
                </table>

                <!--可编辑区域 end-->
                <div class='text-center mt-20'>
                    <a-button type="primary" @click="onSubmit">保存</a-button>
                </div>
            </a-form>
        </div>
    </a-card>
</template>
<script>
import { formMixin } from "@/mixins";
import { financeInvestorManager } from "@/api/finance";
//   import DictSelect from "@/components/other/DictSelect";
import dataCheck from "@/utils/dataCheck";
import {common_controller} from "@/api/commonService";
import { financeDict } from "@/config/variableConfig";

export default {
    name: "companyInfo",
    components: {
        // DictSelect
    },
    mixins: [formMixin],
    data() {
        return {
            financeDict,
            options:[],
            form: {
                id: null,
                name: null,
                email: null,
                investmentField: null,
                companyWebSite: null,
                locationAddress: null,
                prov: null,
                city: null,
                dist: null,
                address: null,
                logo: null,
                unifiedSocialCreditCode: null,
                registrationTime: null,
                legalPerson: null,
                contacts: null,
                post: null,
                contactNumber: null,
                auditStatus: null,
                feedback: null,
                enabled: null,
                experience: null,
                successCases: null,
                views: null,
                keyWord: null,
                briefIntroduction: null,
            },
            rules: {
                name: [dataCheck.required({})],
                email: [dataCheck.required({})],
                investmentField: [dataCheck.required({})],
                companyWebSite: [dataCheck.required({})],
                locationAddress: [dataCheck.required({})],
                prov: [dataCheck.required({})],
                city: [dataCheck.required({})],
                dist: [dataCheck.required({})],
                address: [dataCheck.required({})],
                logo: [],
                unifiedSocialCreditCode: [dataCheck.required({})],
                registrationTime: [dataCheck.required({})],
                legalPerson: [dataCheck.required({})],
                contacts: [dataCheck.required({})],
                post: [dataCheck.required({})],
                contactNumber: [dataCheck.required({}),dataCheck.phone],
                auditStatus: [dataCheck.required({})],
                feedback: [dataCheck.required({})],
                enabled: [dataCheck.required({})],
                experience: [dataCheck.required({})],
                successCases: [dataCheck.required({})],
                views: [dataCheck.required({})],
                keyWord: [dataCheck.required({})],
                briefIntroduction: [dataCheck.required({})],
            },
        }
    },
    computed: {
            submitUrl() {
                if (this.form.id) {
                    return financeInvestorManager.edit
                } else {
                    return financeInvestorManager.add
                }
            }
        },
    created() {
        this.getCorpInfo()
    },
    methods: {
        getDict(){
            this.getAction({
                url:common_controller.getDictDataByGroupNumber,
                params: {
                    groupNumbers: "investmentfield"
                }
            }).then(res=>{
                this.options = res
            })
        },
        getCorpInfo() {
            this.getAction({
                url: financeInvestorManager.investorManagerInfo
            }).then(res => {
                if(res){
                    this.form = res
                }
            })
        },
    },
}
</script>
<style lang="less" scoped>
.border-t {
    border-width: 1px;
    border-style: solid;
    border-color: #dedede;
    border-width: 0;
    border-top-width: 1px;

    .inline-form {
        .ant-form-item {
            display: flex
        }

        .ant-form-item-control-wrapper {
            flex: 1;
        }
    }

    .my-table {
        table-layout: fixed;

        td {
            border: 1px solid #dedede;
            padding: 15px;
        }

        .ant-form-item {
            margin-bottom: 0;
        }
    }
}
</style>